import React from 'react';
import Tabla from './Screens/Tabla';

function App() {
  return (
    <Tabla />
  );
}

export default App